import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Arrow from "../../components/Arrow";
import LocationDetail from "../../components/LocationDetail";
import {
  Key,
  KeyItem,
  LocationDetailItem,
  StyledHome,
  LocationDetailItems,
} from "./Home.style";

const Home = ({ locations, onLocationChange, activeLocationIndex }) => {
  const { t } = useTranslation();

  useEffect(() => {}, []);

  return (
    <StyledHome>
      <Key>
        <KeyItem>
          <Arrow color="#630E34" direction="up" />{" "}
          {t("home.key.averageAnnualChange")}
        </KeyItem>
        <KeyItem>
          <Arrow color="#B61356" direction="up" />{" "}
          {t("home.key.averageQuarterlyChange")}
        </KeyItem>
      </Key>
      <LocationDetailItems>
        {locations.map((location, index) => (
          <LocationDetailItem key={location.title}>
            <LocationDetail
              tabIndex="-1"
              id={index}
              key={index}
              location={location.title}
              detail={location}
              onToggle={onLocationChange}
              active={index === activeLocationIndex}
              aria-label={location.title}
            />
          </LocationDetailItem>
        ))}
      </LocationDetailItems>
    </StyledHome>
  );
};

export default Home;
